module.exports = __webpack_public_path__ + "static/media/back.3d8440a6.jpg";